import { render, staticRenderFns } from "./DistributionRules.vue?vue&type=template&id=4212d272&"
import script from "./DistributionRules.vue?vue&type=script&lang=js&"
export * from "./DistributionRules.vue?vue&type=script&lang=js&"
import style0 from "./DistributionRules.vue?vue&type=style&index=0&id=4212d272&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports